import { render } from "./rating.pug?vue&type=template&id=7bc49cea&ts=true&lang=pug&external"
import script from "./rating.ts?vue&type=script&lang=ts&external"
export * from "./rating.ts?vue&type=script&lang=ts&external"

import "./rating.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__